import Vue from 'vue';
import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';
import { CaptureConsole } from '@sentry/integrations';

if (process.env.VUE_APP_SENTRY_DSN && window.webpackHotUpdate === undefined)
{
    const sentryOptions = {
        Vue,
        dsn: process.env.VUE_APP_SENTRY_DSN,
        environment: process.env.VUE_APP_SENTRY_DEPLOY_ENVIRONMENT,
        trackComponents: true,
        attachProps: true,
        logErrors: Boolean(process.env.VUE_APP_SENTRY_LOG_ERRORS),
        release: process.env.VUE_APP_SENTRY_RELEASE,
        ignoreErrors: ['ResizeObserver loop limit exceeded',
            'ResizeObserver loop completed with undelivered notifications'],

    };

    let sentryTraceOptions = {};
    const sentryTraceSampleRate = parseFloat(process.env.VUE_APP_SENTRY_TRACES_SAMPLE_RATE);

    if (sentryTraceSampleRate && sentryTraceSampleRate > 0)
    {
        sentryTraceOptions = {
            autoSessionTracking: true,
            tracesSampleRate: sentryTraceSampleRate,
            tracingOptions: {
                trackComponents: true,
            },
            integrations: [
                new BrowserTracing(),
                new CaptureConsole({
                    levels: [
                        'warn',
                        'error',
                    ],
                }),
            ],
        };
    }

    Sentry.init({ ...sentryOptions, ...sentryTraceOptions });
}

Vue.prototype.$sentry = Sentry;
